import styled from "styled-components";

// Styled components for CustomerMap functionality
export const MapContainer = styled.div`
    width: 100%;
    height: ${props => (props.mode === "fixed" ? "80vh" : "400px")};
    overflow: hidden;
    border: 2px solid #aef001;
    border-radius: 4px;
    z-index: 1;
    position: relative;
    display: flex;
    flex-direction: column;

    ${({mode}) =>
        mode === "fixed" &&
        `position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 90vw;
        height: 80vh;
        z-index: 9999;
        border: 2px solid #aef001;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        background: white;`}
`;

export const MapTools = styled.button`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 10;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    border: 1px solid #d9d9d9;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 1.5em;
        height: 1.5em;
    }

    &:hover {
        background: #f5f5f5;
        border-color: #40a9ff;
    }
`;
